import { render, staticRenderFns } from "./DiscoArea.vue?vue&type=template&id=0b08ad3e&scoped=true&"
import script from "./DiscoArea.vue?vue&type=script&lang=js&"
export * from "./DiscoArea.vue?vue&type=script&lang=js&"
import style0 from "./DiscoArea.vue?vue&type=style&index=0&id=0b08ad3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b08ad3e",
  null
  
)

export default component.exports